import React from 'react';
import { StyleProp, ViewStyle, Switch, ColorValue } from 'react-native';
import { FontInfo,  } from '../~Utilities/Constants';

interface ISwitchNE
{
style : StyleProp<ViewStyle>;

value? : boolean | undefined;

onValueChange? : ((value: boolean) => void | Promise<void>) | null | undefined;

ios_backgroundColor?: ColorValue | undefined;

trackColor?: {
             false?: ColorValue | null | undefined;
             true?: ColorValue | null | undefined;
             } | undefined
}

/*   ====================================================================   */

export default class SwitchNE extends React.Component<ISwitchNE>
 {
   render() 
     {
      return (
          <Switch style= {this.props.style}
            trackColor={this.props.trackColor}

            thumbColor={"white"}
            activeThumbColor="white"

            ios_backgroundColor={this.props.ios_backgroundColor}
            onValueChange={ this.props.onValueChange }
            value={this.props.value}
          />
      );
   }
}